import { Cta } from "../components/Cta";
import { Section } from "../components/Section";
import { usePageMeta } from "../lib/usePageMeta";

/**
 * The in-app 404.
 *
 * It answers with HTTP 200 and always will: the edge has to serve index.html
 * for every path the router owns, and the edge cannot know which of those the
 * router will refuse. The `noindex` on this page (content/meta.ts) is what
 * stops that mattering — it is the only thing telling a crawler not to keep a
 * soft 404 as a real page. Missing ASSETS are a different matter and do 404
 * properly; see the SpaRouter function in RIPK/api/cdk/lib/kev-edge-stack.ts.
 */
export function NotFound() {
  usePageMeta("notFound");

  return (
    <Section heading="Nothing here" eyebrow="404" tone="ink" level={1}>
      <p style={{ maxWidth: "54ch", color: "var(--body)", marginBottom: 24 }}>
        That page doesn&rsquo;t exist. Might be a stale link.
      </p>
      <nav aria-label="Where to next" style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
        <Cta to="/">Back to the front</Cta>
        <Cta to="/pricing" variant="secondary">
          Pricing
        </Cta>
      </nav>
    </Section>
  );
}
